import React from 'react';
import { size } from 'lodash';

import ShortInfoPreloader from './ShortInfoPreloader';
import SearchParams from './SearchParams';
import type { IShortInfoBlock } from './types';

const baseCls = 'checkout-shortinfo';

const ShortInfoBlock = (props: IShortInfoBlock): JSX.Element => {
  const {
    fetching,
    adults,
    kids,
    startDate,
    endDate,
    isMobile,
    hasAdjustParams,
    instantConfirm,
    isArchived,
  } = props;

  return !isArchived && fetching && startDate && endDate ? (
    <ShortInfoPreloader
      baseCls={baseCls}
      startDate={startDate}
      endDate={endDate}
      touristsCount={adults + size(kids)}
      hasAdjustParams={hasAdjustParams}
      isMobile={isMobile}
    />
  ) : (
    <SearchParams
      isMobile={isMobile}
      hasAdjustParams={hasAdjustParams}
      instantConfirm={instantConfirm}
      isArchived={isArchived}
    />
  );
};

export default ShortInfoBlock;
